import React, { useState } from 'react';
import { useAnalysisWsStore } from 'store/useAnalysisWsStore';
import type { WsConnectionStatus } from 'types/connection';
import { SystemModal } from 'components/system/SystemModal';
import './ComparisonGrid.css';

interface PanelToolbarProps {
	panelCount: number;
	onAdd: () => void;
}

const STATUS_LABEL: Record<WsConnectionStatus, string> = {
	connected: 'Connected',
	connecting: 'Connecting…',
	disconnected: 'Reconnecting…',
	error: 'Disconnected',
};

export function PanelToolbar({ panelCount, onAdd }: PanelToolbarProps) {
	const status = useAnalysisWsStore((s) => s.connectionStatus);
	const [infoOpen, setInfoOpen] = useState(false);

	return (
		<div className='toolbar'>
			<div className='toolbar-left'>
				<span className='brand-sub'>Analysis Debug</span>
			</div>
			<div className='toolbar-right'>
				<div className={`conn-pill conn-${status}`}>
					<span className='conn-dot' />
					{STATUS_LABEL[status]}
				</div>
				<span className='panel-count'>
					{panelCount} {panelCount === 1 ? 'panel' : 'panels'}
				</span>
				<button className='info-btn' type='button' onClick={() => setInfoOpen(true)} title='System status' aria-label='System status'>
					ⓘ
				</button>
				<button className='add-panel-btn' type='button' onClick={onAdd}>
					+ Add panel
				</button>
			</div>
			<SystemModal open={infoOpen} onClose={() => setInfoOpen(false)} />
		</div>
	);
}
